import { IStringDictionary, StringDictionary } from "../../core/StringDictionary";

export class PriceGroupOption implements IPriceGroupOption {
    constructor(priceGroupOption?: IPriceGroupOption) {
        this._priceGroupId = priceGroupOption?.priceGroupId ?? 0;
        this._priceId = priceGroupOption?.priceId ?? 15;
        this.productNumber = priceGroupOption?.productNumber ?? "";
        this.unitCode = priceGroupOption?.unitCode ?? "Each";
        this.unitType = priceGroupOption?.unitType ?? "";
        this.baseUnitPrice = priceGroupOption?.baseUnitPrice ?? 0;
        this.currencyCode = priceGroupOption?.currencyCode ?? "USD";
        this.displayIndex = priceGroupOption?.displayIndex ?? 0;
        this.dictionary = priceGroupOption?.dictionary instanceof StringDictionary ? priceGroupOption.dictionary : new StringDictionary(priceGroupOption?.dictionary);
        this.unitDescription = priceGroupOption?.unitDescription ?? "";
    }

    toJSON(): object {
        // return generic object with properties to stringify
        return {
            priceGroupId: this.priceGroupId,
            priceId: this.priceId,
            productNumber: this.productNumber,
            unitCode: this.unitCode,
            unitType: this.unitType,
            baseUnitPrice: this.baseUnitPrice,
            currencyCode: this.currencyCode,
            displayIndex: this.displayIndex,
            dictionary: this.dictionary,
            visible: this.visible,
            productNumberLabel: this.productNumberLabel,
            unitDescription: this.unitDescription
        };
    }

    private _priceGroupId: number;
    get priceGroupId() { return this._priceGroupId; }
    private _priceId: number;
    get priceId() { return this._priceId; }
    productNumber: string;
    unitCode: string;
    unitType: string;
    baseUnitPrice: number;
    currencyCode: string;
    displayIndex: number;
    dictionary: IStringDictionary;
    unitDescription: string;

    compareTo(other: PriceGroupOption): number {
        if ((this.displayIndex > 0 && other.displayIndex <= 0) ||
            (this.displayIndex > 0 && this.displayIndex < other.displayIndex) ||
            (this.displayIndex === 0 && other.displayIndex < 0))
            return -1;
        if ((this.displayIndex < 0 && other.displayIndex >= 0) ||
            (this.displayIndex > 0 && this.displayIndex > other.displayIndex) ||
            (this.displayIndex === 0 && other.displayIndex > 0))
            return 1;
        return this.productNumberLabel.localeCompare(other.productNumberLabel);
    }

    static toTypedArray(priceGroupOptions?: IPriceGroupOption[]): PriceGroupOption[] {
        if (priceGroupOptions)
            return priceGroupOptions.map((pgo) => new PriceGroupOption(pgo));
        return new Array<PriceGroupOption>();
    }

    // Begin Calculated Fields

    get visible(): boolean {
        return this.displayIndex >= 0;
    }
    set visible(value: boolean) {
        this.displayIndex = value ? 0 : -1;
        //C# has some additional processing of updating the PriceGroupCode here
        //but we don't currently have PriceGroupCode as a member, so I haven't ported that code here yet
    }

    get productNumberLabel(): string {
        return this.dictionary.containsKey("ProductNumber") ? this.dictionary.get("ProductNumber") : "";
    }
    set productNumberLabel(value: string) {
        this.dictionary.set("ProductNumber", value);
    }

    // End Calculated Fields
}

export interface IPriceGroupOption {
    priceGroupId: number;
    priceId: number;
    productNumber: string;
    unitCode: string;
    unitType: string;
    baseUnitPrice: number;
    currencyCode: string;
    displayIndex: number;
    dictionary: IStringDictionary;
    visible: boolean;
    productNumberLabel: string;
    unitDescription: string;
}